export default __webpack_public_path__ + "static/obs-curated-dashboards-431dde1c79bd96a744d4985dde612fe5.png";